import { render, staticRenderFns } from "./ConstructionProjects.vue?vue&type=template&id=0c1749fa&scoped=true&"
import script from "./ConstructionProjects.vue?vue&type=script&lang=js&"
export * from "./ConstructionProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1749fa",
  null
  
)

export default component.exports